import {
    GetMeetingsQuery,
    GetMeetingsQueryVariables,
    GetParticipantsQuery,
    GetParticipantsQueryVariables
} from 'generated/graphql'
import { getNodes } from 'graphql/utils'
import { usePagination, DEFAULT_ITEMS_PER_PAGE } from '../pagination'
import { hostsQuery, meetingsQuery, participantsQuery } from './graphql/query'

const getSpace = (data) => getNodes(data?.event?.meetingSpaces)?.[0]
const getList = (data) => getNodes(getSpace(data)?.meetings)
const getPageInfo = (data) => getSpace(data)?.meetings?.pageInfo
const getTotalCount = (data) => getSpace(data)?.meetings?.totalCount

export const useMeetings = (
    { ...variables }: GetMeetingsQueryVariables
) => usePagination<GetMeetingsQuery, GetMeetingsQueryVariables>({
    query: meetingsQuery,
    initPage: 1,
    initItemsPerPage: DEFAULT_ITEMS_PER_PAGE,
    getList,
    getPageInfo,
    getTotalCount,
    variables,
})

const getParticipantList = (data) => getNodes(getList(data)[0]?.participants)
const getParticipantPageInfo = (data) => getList(data)[0]?.participants?.pageInfo
const getParticipantTotalCount = (data) => getList(data)[0]?.participants?.totalCount

export const useParticipants = (
    { ...variables }: GetParticipantsQueryVariables
) => usePagination<GetParticipantsQuery, GetParticipantsQueryVariables>({
    query: participantsQuery,
    initPage: 1,
    initItemsPerPage: DEFAULT_ITEMS_PER_PAGE,
    getList: getParticipantList,
    getPageInfo: getParticipantPageInfo,
    getTotalCount: getParticipantTotalCount,
    variables,
})

const getHostList = (data) => getNodes(getList(data)[0]?.hosts)
const getHostPageInfo = (data) => getList(data)[0]?.hosts?.pageInfo
const getHostTotalCount = (data) => getList(data)[0]?.hosts?.totalCount

export const useHosts = (
    { ...variables }: GetParticipantsQueryVariables
) => usePagination<GetParticipantsQuery, GetParticipantsQueryVariables>({
    query: hostsQuery,
    initPage: 1,
    initItemsPerPage: DEFAULT_ITEMS_PER_PAGE,
    getList: getHostList,
    getPageInfo: getHostPageInfo,
    getTotalCount: getHostTotalCount,
    variables,
})
